import { coreExtensionData } from '@backstage/frontend-plugin-api';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { Fragment } from 'react';

const catalogPageWithGovernance = catalogPlugin
  .getExtension('page:catalog')
  .override({
    factory(originalFactory, { inputs, config }) {
      const filters = inputs.filters.map(filter =>
        filter.get(coreExtensionData.reactElement),
      );
      return originalFactory({
        params: {
          loader: async () => {
            const { GovernedCatalogPage } = await import(
              './GovernedCatalogPage'
            );
            return (
              <GovernedCatalogPage
                filters={<Fragment>{filters}</Fragment>}
                pagination={config.pagination}
              />
            );
          },
        },
      });
    },
  });

export const governanceCatalogPlugin = catalogPlugin.withOverrides({
  extensions: [catalogPageWithGovernance],
});
